/* import __COLOCATED_TEMPLATE__ from './custom-object-type-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();